export * from './translate.loader';
export * from '../../../../common/translate';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/translate/index.ts